import * as React from 'react';
import { tokens } from '../theme';

import { Box, IconButton, InputBase, Grid, useTheme } from '@mui/material';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import SearchIcon from '@mui/icons-material/Search';
import ToolbarFilterButton from './ToolbarFilterButton';
import DatePickerDropdownButton from './DatePickerDropdownButton';
import { useEffect, useState } from 'react';

const SearchBarFilter = ({ filterProps, onSearch }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [searchQueryPlaceholder, setSearchQueryPlaceholder] =
        useState('Search Name');
    const [searchQuery, setSearchQuery] = useState('');
    const [filter, setFilter] = useState('');
    const [filterCriteria, setFilterCriteria] = useState([
        {
            keyValue: '',
            displayName: '',
            paramName: '',
            isDateFilter: false,
            isSearchBarDropdown: false,
            searchBarDropdownOptions: [],
        },
    ]);
    const [filterDisplayOptions, setFilterDisplayOptions] = useState([]);
    const [defaultFilter, setDefaultFilter] = useState('');
    const [isDateFilterSelected, setIsDateFilterSelected] = useState(false);
    const [showSearchBarDropdown, setShowSearchBarDropdown] = useState(false);
    const [searchBarDropdownOptions, setSearchBarDropdownOptions] = useState(
        []
    );
    const [anchorEl, setAnchorEl] = useState(null);
    const hasInitializedFilter = React.useRef(false);

    // filterProps is an array of objects with the following structure:
    // [
    //   {
    //     "keyValue": "Name",
    //     "displayName": "Name",
    //     "paramName": "name"
    //     "isDateFilter": false,
    //     "isSearchBarDropdown": false
    //     "searchBarDropdownOptions": []
    //   },
    // ]
    useEffect(() => {
        console.log('Filter Props: ', filterProps);

        setFilterCriteria(filterProps);
        setFilterDisplayOptions(
            filterProps.map((filter) => filter.displayName)
        );

        // setDefaultFilter(filterProps[0].displayName);
        setFilter(filterProps[0]);
    }, []);

    // clear search query when a new filter is selected
    useEffect(() => {
        console.log('Filter changed to: ', filter);

        if (!filter || !filter.paramName) {
            return;
        }

        const placeholder = 'Search ' + filter.displayName;
        setSearchQueryPlaceholder(placeholder);
        setSearchQuery('');

        if (!hasInitializedFilter.current) {
            hasInitializedFilter.current = true;
            return;
        }

        handleSearchButtonClicked('');
    }, [filter]);

    const handleFilterChange = (filter) => {
        // find the right filterCriteria based on the selected filter
        const selectedFilter = filterCriteria.find(
            (item) => item.displayName === filter
        );
        setFilter(selectedFilter);

        // manage filter type if it is a date filter or a search bar dropdown
        setIsDateFilterSelected(selectedFilter.isDateFilter);
        setShowSearchBarDropdown(selectedFilter.isSearchBarDropdown);
        setSearchBarDropdownOptions(selectedFilter.searchBarDropdownOptions);
    };

    const handleSearchBarDropdownSelect = (selectedValue) => {
        const selectedDropdownValue = selectedValue;
        setSearchQuery(selectedDropdownValue);
        handleCloseSearchBarDropdown();

        handleSearchButtonClicked(selectedDropdownValue);
    };

    const handleOpenSearchBarDropdown = (event) => {
        if (showSearchBarDropdown) {
            setAnchorEl(event.currentTarget);
        }
    };

    const handleCloseSearchBarDropdown = () => {
        setAnchorEl(null);
    };

    function handleSearchButtonClicked(instantSearchQuery) {
        if (instantSearchQuery != null && instantSearchQuery != undefined) {
            onSearch(filter.paramName, instantSearchQuery);
        } else {
            onSearch(filter.paramName, searchQuery);
        }
    }

    return (
        <Grid container direction={'row'}>
            {/* Conditional Rendering */}
            {isDateFilterSelected ? (
                <Box
                    backgroundColor={colors.grey[900]}
                    borderRadius="20px"
                    ml={5}
                    mr={2}
                >
                    <DatePickerDropdownButton
                        onDateSelect={(selectedDate) => {
                            setSearchQuery(selectedDate);
                            handleSearchButtonClicked(selectedDate);
                        }}
                    />
                </Box>
            ) : (
                <Box
                    backgroundColor={colors.grey[900]}
                    borderRadius="20px"
                    ml={5}
                    mr={2}
                    sx={{boxShadow: '0px 12px 24px 0px rgba(0, 0, 0, 0.08)'}}
                >
                    <InputBase
                        sx={{
                            ml: 2,
                            flex: 1,
                            paddingLeft: '3px',
                        }}
                        placeholder={searchQueryPlaceholder}
                        value={searchQuery}
                        onClick={handleOpenSearchBarDropdown}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                handleSearchButtonClicked();
                                e.preventDefault();
                            }
                        }}
                    />
                    <Menu
                        id="simple-menu"
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl) && showSearchBarDropdown}
                        onClose={handleCloseSearchBarDropdown}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                    >
                        {searchBarDropdownOptions.map((status) => (
                            <MenuItem
                                key={status}
                                onClick={() =>
                                    handleSearchBarDropdownSelect(status)
                                }
                            >
                                {status}
                            </MenuItem>
                        ))}
                    </Menu>
                    <IconButton
                        type="button"
                        sx={{ p: 1 }}
                        onClick={() => handleSearchButtonClicked()}
                    >
                        <SearchIcon />
                    </IconButton>
                </Box>
            )}
            <ToolbarFilterButton
                options={filterDisplayOptions}
                defaultOption={defaultFilter}
                onChange={handleFilterChange}
                name={'FILTERS'}
            />
        </Grid>
    );
};

export default SearchBarFilter;
